import { useSelector } from "react-redux";
import ReportRepository from "src/repository/Admin/ReportRepository";
import { getReportsList, setReportsList, setReportsListMessage } from "src/store/slice/model/Admin/Reports";
import store from "src/storeWire";


export function useReportsStore() {
    const reportsList = useSelector((state) => state.entities.model_Admin_Reports_list.reportsList)
    const totalRecords = useSelector((state) => state.entities.model_Admin_Reports_list.totalRecords)
    const filteredRecords = useSelector((state) => state.entities.model_Admin_Reports_list.filteredRecords)
    const reportsListMessage = useSelector((state) => state.entities.model_Admin_Reports_list.reportsListMessage)

    let data = {
        reportsList,
        totalRecords,
        filteredRecords,
        reportsListMessage
    };

    let fetch = {
        get_reports_list: async (params) => {
            return await store.dispatch(getReportsList(params))
        },
        get_export_report_list: async (params) => {
            return await new ReportRepository().getExportReportList(params);
        },
        email_report_list: async (params) => {
            return await new ReportRepository().emailReportList(params);
        },
    };
    let set = {
        set_reports_list: () => {
            return store.dispatch(setReportsList([]));
        },
        set_reports_list_message: (message) => {
            return store.dispatch(setReportsListMessage(message));
        },

    };
    return [data, fetch, set]
}
